import { Typography } from '@mui/material';
import { styled } from '@mui/styles';
import { useHideLimitedCompanyShiftFields } from 'ogp/limited-company-capabilities';
import React from 'react';
import { CalendarJobType } from './calendar-job-type';
import { CalendarPlanningJobType } from '../calendar-planning-job-type.types';

export type GridDepartmentProps = {
  department: {
    id: string;
    name: string;
    hideDepartmentHeader?: boolean;
    jobTypes: CalendarPlanningJobType[];
  };
  hideTopBorderOnFirstJobType?: boolean;
};

export const CalendarDepartment = React.memo(
  ({ department, hideTopBorderOnFirstJobType }: GridDepartmentProps) => {
    const hideLimitedCompanyShiftFields = useHideLimitedCompanyShiftFields();

    return (
      <Section>
        {hideLimitedCompanyShiftFields || department.hideDepartmentHeader ? null : (
          <StyledName title={department.name}>{department.name}</StyledName>
        )}
        {department.jobTypes.length ? (
          department.jobTypes.map((jobType, jobTypeIndex) => (
            <CalendarJobType
              key={jobType.id}
              jobType={jobType}
              hideTopBorder={hideTopBorderOnFirstJobType === true && jobTypeIndex === 0}
            />
          ))
        ) : (
          <CalendarJobType jobType={undefined} />
        )}
      </Section>
    );
  },
  (prev, next) => {
    if (prev.hideTopBorderOnFirstJobType !== next.hideTopBorderOnFirstJobType) {
      return false;
    }
    if (prev.department.id !== next.department.id) {
      return false;
    }
    if (prev.department.jobTypes.length !== next.department.jobTypes.length) {
      return false;
    }
    if (JSON.stringify(prev.department) !== JSON.stringify(next.department)) {
      return false;
    }
    return true;
  }
);

const Section = styled('section')(({ theme }) => ({
  minHeight: theme.spacing(8),
}));

const StyledName = styled(Typography)(() => ({
  fontWeight: 700,
  width: '14vw',
  position: 'relative',
  transform: 'translateY(-20%)',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'pre',
}));
